import { CorporateBusinessType } from '../../enum/corporate-business-type.enum';
import { AttachmentInfo } from '../attachment/attachment-info';
import { CampaignInfo } from '../campaign/campaign-info';
import { CompanyDetails } from './company-details';
import { Sector } from './sector';
import { SocialLink } from './social-link';

export class CompanyModel {
  id: number;
  name: string;
  registrationNumber: string;
  tagline: string;
  address: string;
  postCode: string;
  city: string;
  state: string;
  stateId: string;
  country: string;
  countryId: string;
  businessAddress: string;
  businessPostCode: string;
  businessCity: string;
  busienssStateId: string;
  businessCountryId: string;
  phoneNumber: string;
  companySectors: Sector[];
  companyLogoAttachment: AttachmentInfo;
  companyLogoUrl: string;
  companyType: CorporateBusinessType;
  otherCompanyType: string;
  email: string;
  incorporatedDate: string;
  companySocialLinks: SocialLink[];
  websiteUrl: string;
  companyBannerAttachment: AttachmentInfo;
  companyBannerUrl: string;
  companyDetail: CompanyDetails;
  videoUrl: string;
  msicCodes: string[];
  grossAnnualRevenueType: number;
  corporateCategoryType: number;
  othersCorporateCategoryType: string;
  latestCampaign?: CampaignInfo;
}
